module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-forgot-page"
  }, [_c('div', {
    staticClass: "sk-topbar"
  }, [_c('a', {
    staticClass: "sk-logo",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "width": "auto",
      "display": "block"
    },
    attrs: {
      "src": "https://sentrykit.com/wp-content/uploads/2026/04/Sk-2.0-logo-white.png",
      "alt": "SentryKit"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sk-main"
  }, [_c('div', {
    staticClass: "sk-card"
  }, [_vm._m(0), _vm._v(" "), (_vm.response === 200) ? _c('div', {
    staticClass: "sk-success-msg"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    }
  })]), _vm._v("\n        Password reset email has been sent. Check your inbox.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.response !== null && _vm.response !== 200) ? _c('div', {
    staticClass: "sk-error-msg"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "stroke-width": "2",
      "d": "M12 8v4m0 4h.01"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.response === 404 ? 'We could not find this email address in our database.' : 'There was a problem sending the reset email. Please try again.') + "\n      ")]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendPasswordResetEmail.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "sk-form-row"
  }, [_c('div', {
    staticClass: "sk-field"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "sk-input",
    attrs: {
      "type": "email",
      "placeholder": "you@company.com",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "sk-btn sk-btn-primary sk-mt-6",
    class: {
      loading: _vm.working
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.working || _vm.sent
    }
  }, [(_vm.working) ? _c('span', {
    staticClass: "sk-spinner"
  }) : _c('span', [_vm._v(_vm._s(_vm.sent ? 'Email Sent ✓' : 'Send Reset Link →'))])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-login-link"
  }, [_vm._v("Remember your password? "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log in")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-card-header"
  }, [_c('h2', [_vm._v("Reset your password")]), _vm._v(" "), _c('p', [_vm._v("Enter your email address and we'll send you a link to reset your password.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Email Address "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d420b0f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ForgotPasswordPage.vue
// module id = 812
// module chunks = 2